import { create } from "zustand";

/**
 * Non-persisted flag raised when the backend rejects a request with
 * 403 `second_factor_required` — i.e. an authenticated session that predates
 * 2FA enforcement must prove its second factor before using protected features.
 * Cleared once the session is upgraded (or on logout).
 */
interface SecondFactorGateState {
  pending: boolean;
  setPending: (pending: boolean) => void;
}

export const useSecondFactorGate = create<SecondFactorGateState>((set) => ({
  pending: false,
  setPending: (pending) => set({ pending }),
}));
